import { Collapsible } from '../../components/Collapsible';
import type { ParsedSpec } from './types';

interface Props {
  spec: ParsedSpec;
  onReset: () => void;
}

export function CuttingDataTable({ spec, onReset }: Props) {
  const { cuttingData } = spec;

  const linearRows = cuttingData.filter((r) => r.unit === 'м');
  const areaRows = cuttingData.filter((r) => r.unit === 'м2');
  const otherRows = cuttingData.filter((r) => r.unit !== 'м' && r.unit !== 'м2');

  const uniqueMaterials = new Set(cuttingData.map((r) => r.material)).size;

  const subtitle = [
    `${cuttingData.length} позиций`,
    `${uniqueMaterials} материалов`,
    linearRows.length > 0 && `${linearRows.length} линейных (м)`,
    areaRows.length > 0 && `${areaRows.length} листовых (м²)`,
    otherRows.length > 0 && `${otherRows.length} прочих`,
  ]
    .filter(Boolean)
    .join(' · ');

  const headerRight = (
    <button
      onClick={(e) => {
        e.stopPropagation();
        onReset();
      }}
      className="text-xs text-gray-400 hover:text-gray-600 border border-gray-200 rounded px-2.5 py-1 transition-colors"
    >
      Загрузить другой файл
    </button>
  );

  return (
    <Collapsible
      title={
        <span>
          Данные для раскроя
          <span
            className="ml-2 text-xs text-gray-400 font-normal"
            style={{ fontFamily: 'Inter, sans-serif' }}
          >
            {subtitle}
          </span>
        </span>
      }
      defaultOpen={false}
      headerRight={headerRight}
    >
      <div className="overflow-x-auto">
        <table className="w-full text-sm text-left">
          <thead>
            <tr className="bg-gray-50 text-xs text-gray-500 uppercase tracking-wide">
              <th className="px-3 py-2 font-medium w-10">№</th>
              <th className="px-3 py-2 font-medium">Материал</th>
              <th className="px-3 py-2 font-medium">Тип детали</th>
              <th className="px-3 py-2 font-medium text-right">Кол-во мат.</th>
              <th className="px-3 py-2 font-medium">Ед.</th>
              <th className="px-3 py-2 font-medium text-right">Кол-во, шт.</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-50">
            {cuttingData.map((row) => (
              <tr
                key={row.index}
                className={[
                  'hover:bg-gray-50 transition-colors',
                  row.unit === 'м' ? 'text-gray-900' : 'text-gray-500',
                ].join(' ')}
              >
                <td className="px-3 py-1.5 tabular-nums text-gray-400">{row.index}</td>
                <td className="px-3 py-1.5 max-w-xs truncate" title={row.material}>
                  {row.material}
                </td>
                <td className="px-3 py-1.5 text-gray-500">{row.partType}</td>
                <td className="px-3 py-1.5 tabular-nums text-right">{formatQty(row.materialQty)}</td>
                <td className="px-3 py-1.5 text-gray-500">{row.unit}</td>
                <td className="px-3 py-1.5 tabular-nums text-right font-medium">{row.totalQty}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Collapsible>
  );
}

function formatQty(n: number): string {
  if (Number.isInteger(n)) return String(n);
  return n.toPrecision(4).replace(/\.?0+$/, '');
}
